import {
  ChangeDetectorRef,
  Component,
  effect,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  Output,
  signal,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { NgForOf, NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { getState } from '@ngrx/signals';
import { Colorset } from '../../../models/colorset';
import { ColorsComponent } from '../colors/colors.component';
import { ColorsetStore } from '../../../stores/colorset/colorset.state';
import { FormFieldWrapperComponent } from '../../molecules/form-field-wrapper/form-field-wrapper.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { Button } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { GlobalsStore } from '../../../stores/globals.state';

@Component({
  selector: 'app-colorset-dropdown',
  standalone: true,
  imports: [
    DropdownModule,
    NgIf,
    SharedModule,
    FormsModule,
    ColorsComponent,
    NgForOf,
    ReactiveFormsModule,
    FormFieldWrapperComponent,
    MultiSelectModule,
    Button,
    DialogModule,
  ],
  templateUrl: './colorset-dropdown.component.html',
  styleUrl: './colorset-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorsetDropdownComponent),
      multi: true,
    },
  ],
})
export class ColorsetDropdownComponent implements ControlValueAccessor {
  readonly globalsStore = inject(GlobalsStore);
  readonly colorsetStore = inject(ColorsetStore);

  @Input() label = 'Farbset';
  @Input() name = 'colorset';
  @Input() selection: Colorset | null = null;
  @Input() disabled = false;
  @Input() colSize: string | number = 12;
  @Input() enableNewOption = false;
  @Output() selectionChange = new EventEmitter<Colorset | null>();

  touched = false;
  colorsets: Colorset[] = [];

  constructor() {
    effect(() => {
      const colorsetState = getState(this.colorsetStore);
      this.colorsets = this.colorsetStore.asArray();

      if (colorsetState.selectedId) {
        this.selection = this.colorsetStore.getById(colorsetState.selectedId);
        this.selectionChange.emit(this.selection);
      }
    });
  }

  onChange = (value: Colorset | null) => {
    setTimeout(() => {
      this.selectionChange.emit(value);
    }, 100);
  };

  onDropdownChange(value: string | null) {
    this.selectionChange.emit(value ? this.colorsetStore.getById(value) : null);
  }

  // Call this method whenever the selection changes
  onSelectionChange(event: any): void {
    this.selection = event.value;
    this.onChange(this.selection); // Notify the form control of the change
    this.onTouched();
  }

  private onTouched = () => {
    this.touched = false;
  };

  writeValue(value: Colorset): void {
    this.selection = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  openColorsetForm() {
    this.globalsStore.triggerAtlasEvent('addColorsetDialog', {});
  }
}
